import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/*
 * The Aurora sky: three blurred colour auras fixed to the viewport, prepended to <body> so they
 * sit above the page ground and below every positioned surface (styles in themes/aurora.css).
 * Mounted once by Layout, so every page shares the same light.
 */
function useBodyHost() {
  const [host] = useState(() => {
    if (typeof document === 'undefined') return null;
    const el = document.createElement('div');
    el.className = 'aurora-sky';
    el.setAttribute('aria-hidden', 'true');
    return el;
  });
  useLayoutEffect(() => {
    if (!host) return undefined;
    document.body.prepend(host);
    return () => host.remove();
  }, [host]);
  return host;
}

export default function AuroraSky() {
  const host = useBodyHost();
  if (!host) return null;
  return createPortal(
    <>
      <span className="aurora-orb aurora-orb-1" />
      <span className="aurora-orb aurora-orb-2" />
      <span className="aurora-orb aurora-orb-3" />
    </>,
    host
  );
}

